/* Bewertungen der Produktseite (03.11.2026): Weiterlesen, Weitere laden, Grossansicht, Formular. Keine Bibliothek, kein Abruf beim Laden.
   Die Reihenfolge der Karten kommt fertig aus Shopify (erst mit Fotos, dann ohne, je neueste zuerst); das Skript sortiert und filtert nichts.
   Abrufe gibt es nur nach einem Klick: Weitere Karten kommen von Shopify (?view=bewertungen&page_<kennung>=n), das Formular geht an data-api (new-era.cloud). Ist der Server weg, bleibt die Seite wie sie ist. */
(function () {
  'use strict'
  var root = document.querySelector('[data-fl-bw]')
  if (!root) return
  root.classList.add('fl-bw--js')
  var q = function (s, r) { return (r || root).querySelector(s) }
  var qa = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)) }
  var T = {}
  try { T = JSON.parse(q('[data-fl-texte]').textContent) } catch (e) { T = {} }
  /* Der t-Filter von Shopify maskiert seine Texte (aus ' wird &#39;); als textContent gesetzt, stuende das so auf der Seite. Einmal zurueckwandeln. */
  var wandler = document.createElement('textarea')
  Object.keys(T).forEach(function (k) { wandler.innerHTML = T[k]; T[k] = wandler.value })
  var liste = q('[data-fl-liste]')
  var seite = 1
  var seiten = liste ? parseInt(liste.getAttribute('data-seiten'), 10) || 1 : 1
  var laedt = false
  var mehrKnopf = q('[data-fl-mehr]')

  /* ---- Weiterlesen: der Text ist per CSS auf 6 Zeilen gekuerzt; der Knopf erscheint nur, wenn wirklich etwas fehlt, und klappt die eine Karte auf ---- */
  function messen () {
    qa('.fl-bw__karte', liste || root).forEach(function (k) {
      if (k.classList.contains('fl-bw__karte--auf')) return
      var t = q('.fl-bw__text', k)
      var kn = q('[data-fl-lesen]', k)
      if (t && kn) kn.hidden = !(t.scrollHeight > t.clientHeight + 1)
    })
  }
  if (liste) {
    liste.addEventListener('click', function (e) {
      var kn = e.target.closest ? e.target.closest('[data-fl-lesen]') : null
      if (!kn) return
      var k = kn.closest('.fl-bw__karte')
      var auf = !k.classList.contains('fl-bw__karte--auf')
      k.classList.toggle('fl-bw__karte--auf', auf)
      kn.setAttribute('aria-expanded', String(auf))
      kn.textContent = auf ? (T.weniger || '') : (T.weiterlesen || '')
      if (!auf) messen()
    })
    messen()
    window.addEventListener('load', messen)
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(messen)
    var rz
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(messen, 150) })
  }

  /* ---- Weitere Karten von Shopify ---- */
  /* Shopify blaettert eine Metafeld-Liste mit page_<kennung>=n, nicht mit page=n (dann kaeme immer Seite 1); den Namen liefert die Adresse der naechsten Seite (data-weiter). */
  var seitenName = (/[?&](page[^=&]*)=2(?:&|$)/.exec(liste ? liste.getAttribute('data-weiter') || '' : '') || [0, 'page'])[1]
  /* ansicht: 'bewertungen' (10 je Seite). Zurueck kommen nur Karten, die noch nicht da sind (data-id). */
  function holeSeite (ansicht, n) {
    return fetch(location.pathname + '?view=' + ansicht + '&' + seitenName + '=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text() })
      .then(function (h) {
        var t = document.createElement('template')
        t.innerHTML = h
        return qa('.fl-bw__karte', t.content).filter(function (k) { return !liste.querySelector('.fl-bw__karte[data-id="' + k.getAttribute('data-id') + '"]') })
      })
  }
  /* Die naechste Seite mit mindestens einer neuen Karte (eine Seite nur mit schon gezeigten Karten wird uebersprungen); bis zur letzten Seite, danach ohne Karten. */
  function naechsteNeue (n) {
    return holeSeite('bewertungen', n).then(function (neue) {
      if (neue.length || n >= seiten) return { neue: neue, n: n }
      return naechsteNeue(n + 1)
    })
  }
  function laden () {
    if (laedt || seite >= seiten || !liste) return
    laedt = true
    var fehler = q('[data-fl-mehrfehler]')
    if (fehler) fehler.hidden = true
    root.setAttribute('aria-busy', 'true')
    if (mehrKnopf) { mehrKnopf.disabled = true; mehrKnopf.textContent = T.laedt || '…' }
    naechsteNeue(seite + 1)
      .then(function (r) {
        r.neue.forEach(function (k) { liste.appendChild(k) })
        seite = r.n   // enthielt eine Seite nur schon gezeigte Karten, zaehlt sie trotzdem; ohne Neues bis zum Ende steht seite bei seiten, der Knopf geht weg
        messen()
      })
      .catch(function () {
        if (fehler) { fehler.textContent = T.mehr_fehler || ''; fehler.hidden = false }
      })
      .then(function () {
        laedt = false
        root.removeAttribute('aria-busy')
        if (mehrKnopf) { mehrKnopf.disabled = false; mehrKnopf.textContent = T.mehr || ''; mehrKnopf.hidden = seite >= seiten }
      })
  }
  if (liste && seiten > 1 && mehrKnopf) mehrKnopf.hidden = false
  if (mehrKnopf) mehrKnopf.addEventListener('click', laden)

  /* ---- Grossansicht ---- */
  var licht = q('[data-fl-licht]')
  var bild = q('[data-fl-licht-bild]')
  var galerie = []
  var pos = 0
  function zeige (i) {
    if (!galerie.length) return
    pos = (i + galerie.length) % galerie.length
    bild.src = galerie[pos].url
    bild.alt = galerie[pos].alt
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-fl-foto]') : null
    if (!b || !licht || !licht.showModal) return
    var seen = {}
    galerie = []
    qa('[data-fl-foto]').forEach(function (x) {
      var u = x.getAttribute('data-gross')
      if (seen[u] !== undefined) return
      var i = x.querySelector('img')
      seen[u] = galerie.length
      galerie.push({ url: u, alt: i ? i.alt : '' })
    })
    if (galerie.length < 2) licht.setAttribute('data-eins', ''); else licht.removeAttribute('data-eins')
    zeige(seen[b.getAttribute('data-gross')])
    licht.showModal()
  })
  if (licht) {
    q('[data-fl-licht-zu]').addEventListener('click', function () { licht.close() })
    q('[data-fl-licht-zurueck]').addEventListener('click', function () { zeige(pos - 1) })
    q('[data-fl-licht-weiter]').addEventListener('click', function () { zeige(pos + 1) })
    licht.addEventListener('click', function (e) { if (e.target === licht) licht.close() })
    licht.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') zeige(pos - 1)
      else if (e.key === 'ArrowRight') zeige(pos + 1)
    })
    licht.addEventListener('close', function () { bild.removeAttribute('src') })
  }

  /* ---- Formular ---- */
  var wrap = q('[data-fl-formwrap]')
  var form = q('[data-fl-form]')
  var fehlerZeile = q('[data-fl-fehler]')
  var danke = q('[data-fl-danke]')
  var senden = q('[data-fl-senden]')
  var fotoWahl = q('[data-fl-fotowahl]')
  var vorschau = q('[data-fl-vorschau]')
  var MAX_BYTES = 8 * 1024 * 1024
  var MAX_FOTOS = 5
  /* Fehlercode der Schnittstelle (new-era.cloud, src/modules/bewertungen) -> Schluessel der Sprachtexte. Was fehlt, bekommt den allgemeinen Satz. */
  var CODES = {
    sterne: 'sterne', titel: 'titel', text: 'text', name: 'name', email: 'email', produkt: 'allgemein', produktUnbekannt: 'allgemein',
    fotosZuViele: 'fotos_viele', zuGross: 'foto_gross', keinBild: 'foto_format', unlesbar: 'foto_format', heic: 'foto_heic', zuVieleBildpunkte: 'foto_pixel',
    schonBewertet: 'schon', emailTag: 'heute', ipTag: 'heute', tagGesamt: 'heute', zuViele: 'heute',
    spaeter: 'spaeter', ausgelastet: 'spaeter', gesperrt: 'spaeter', kaputt: 'spaeter', netz: 'netz'
  }
  function meldung (code) {
    fehlerZeile.textContent = T[CODES[code] || 'allgemein'] || ''
    fehlerZeile.hidden = false
  }
  qa('[data-fl-schreiben]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!wrap) return
      wrap.hidden = false
      form.hidden = false
      danke.hidden = true
      qa('[data-fl-schreiben]').forEach(function (x) { x.setAttribute('aria-expanded', 'true') })
      /* Das Formular steht direkt unter dem Knopf; die Seite scrollt so, dass sein Anfang sichtbar ist (scroll-margin-top im CSS haelt die Kopfleiste frei). */
      wrap.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' })
      var erstes = q('input[name=sterne]', form)
      if (erstes) erstes.focus({ preventScroll: true })
    })
  })
  var abbrechen = q('[data-fl-abbrechen]')
  if (abbrechen) abbrechen.addEventListener('click', function () {
    wrap.hidden = true
    qa('[data-fl-schreiben]').forEach(function (x) { x.setAttribute('aria-expanded', 'false') })
  })
  function vorschauLeeren () {
    qa('img', vorschau).forEach(function (i) { URL.revokeObjectURL(i.src) })
    vorschau.textContent = ''
  }
  /* Ziehen und Ablegen auf das Foto-Feld: die Dateien gehen in das versteckte Dateifeld, danach laeuft dieselbe Pruefung wie beim Waehlen. */
  var drop = q('[data-fl-drop]')
  if (drop && fotoWahl) {
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('fl-bw__drop--an') }) })
    ;['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('fl-bw__drop--an') }) })
    drop.addEventListener('drop', function (e) {
      var d = e.dataTransfer
      if (!d || !d.files || !d.files.length) return
      try { fotoWahl.files = d.files } catch (x) { return }
      fotoWahl.dispatchEvent(new Event('change'))
    })
  }
  if (fotoWahl) fotoWahl.addEventListener('change', function () {
    vorschauLeeren()
    fehlerZeile.hidden = true
    var dateien = Array.prototype.slice.call(fotoWahl.files)
    if (dateien.length > MAX_FOTOS) { fotoWahl.value = ''; return meldung('fotosZuViele') }
    for (var i = 0; i < dateien.length; i++) {
      if (dateien[i].size > MAX_BYTES) { fotoWahl.value = ''; return meldung('zuGross') }
    }
    dateien.forEach(function (f) {
      var img = document.createElement('img')
      img.alt = ''
      img.src = URL.createObjectURL(f)
      vorschau.appendChild(img)
    })
  })
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault()
    fehlerZeile.hidden = true
    if (!form.reportValidity()) return
    var fd = new FormData(form)
    if (!fotoWahl.files.length) fd.delete('fotos')
    fd.set('produkt_id', root.getAttribute('data-produkt'))
    fd.set('sprache', root.getAttribute('data-sprache') || '')
    senden.disabled = true
    senden.textContent = T.sendet || '…'
    var ac = typeof AbortController === 'function' ? new AbortController() : null
    var frist = setTimeout(function () { if (ac) ac.abort() }, 90000)
    fetch(root.getAttribute('data-api'), { method: 'POST', body: fd, signal: ac ? ac.signal : undefined })
      .then(function (r) { return r.json().catch(function () { return {} }).then(function (j) { return { ok: r.ok, j: j } }) })
      .then(function (x) {
        if (x.ok && x.j && x.j.ok) {
          form.reset()
          vorschauLeeren()
          form.hidden = true
          danke.hidden = false
          danke.setAttribute('tabindex', '-1')
          danke.focus({ preventScroll: true })
        } else meldung(x.j && x.j.code)
      })
      .catch(function () { meldung('netz') })
      .then(function () {
        clearTimeout(frist)
        senden.disabled = false
        senden.textContent = T.senden || ''
      })
  })
})()
